export const FETCH_DEALS_FAILURE = 'FETCH_DEALS_FAILURE';
export const FETCH_DEALS_REQUEST = 'FETCH_DEALS_REQUEST';
export const FETCH_DEALS_SUCCESS = 'FETCH_DEALS_SUCCESS';
export const CHECK_OUT_USER = 'CHECK_OUT_USER';
export const SELECT_VEHICLE = 'SELECT_VEHICLE';
export const SHOW_CUSTOMER_VEHICLES_SLIDEOUT = 'SHOW_CUSTOMER_VEHICLES_SLIDEOUT';
export const HIDE_CUSTOMER_VEHICLES_SLIDEOUT = 'HIDE_CUSTOMER_VEHICLES_SLIDEOUT';
export const SET_SV_DEAL_LIST_COMPARE_ENABLED = 'SET_SV_DEAL_LIST_COMPARE_ENABLED';
export const FETCH_TRADE_INS_REQUEST = 'FETCH_TRADE_INS_REQUEST';
export const FETCH_TRADE_INS_SUCCESS = 'FETCH_TRADE_INS_SUCCESS';
export const FETCH_TRADE_INS_FAILURE = 'FETCH_TRADE_INS_FAILURE';
export const SELECTED_DEAL = 'SELECTED_DEAL';
export const SET_DEAL_LIST_COMPARE_ENABLED = 'SET_DEAL_LIST_COMPARE_ENABLED';
export const CONTINUE_TO_APPLY_DEAL = 'CONTINUE_TO_APPLY_DEAL';
export const PAYMENT_FAILURE = 'PAYMENT_FAILURE';
export const SP_DXG_SAVE_REQUEST_FAILURE = 'SP_DXG_SAVE_REQUEST_FAILURE';
export const SHOW_TRADE_IN_MODAL = 'SHOW_TRADE_IN_MODAL';
export const HIDE_TRADE_IN_MODAL = 'HIDE_TRADE_IN_MODAL';
